// @flow

import * as React from 'react';
import { createFragmentContainer, graphql } from 'react-relay/compat';
import AgentBadge from 'app/components/AgentBadge';
import AgentUpgradeBanner from 'app/components/AgentUpgradeBanner';
import { AttributeTable, AttributeTableRow } from 'app/components/shared/AttributeTable';
import JobEvent from '../JobEvent';
import type { JobEventAccepted_event } from './__generated__/JobEventAccepted_event.graphql';

type Props = {
  event: JobEventAccepted_event,
  previousTimestamp: ?string
};

function JobEventAccepted({ event, previousTimestamp }: Props) {
  const { job: { agent }, timestamp } = event;

  return (
    <JobEvent timestamp={timestamp} previousTimestamp={previousTimestamp}>
      <JobEvent.Label>
        {agent ? (<AgentBadge agent={agent} />) : 'Agent'} Accepted Job
      </JobEvent.Label>
      { agent ? (
        <JobEvent.Content>
          {agent.versionHasKnownIssues ? <AgentUpgradeBanner agent={agent} /> : null}
          <AttributeTable>
            <AttributeTableRow title="Host name">
              <code className="dark-gray monospace">
                {agent.hostname}
              </code>
            </AttributeTableRow>
            {agent.operatingSystem ? (
              <AttributeTableRow title="Operating System">
                <code className="dark-gray monospace">
                  {agent.operatingSystem.name}
                </code>
              </AttributeTableRow>
            ) : null}
            <AttributeTableRow title="Agent Version">
              <code className="dark-gray monospace">
                {agent.version}
              </code>
            </AttributeTableRow>
          </AttributeTable>
        </JobEvent.Content>
      ) : null}
    </JobEvent>
  );
}

export default createFragmentContainer(JobEventAccepted, {
  event: graphql`
    fragment JobEventAccepted_event on JobEvent {
      ... on JobEvent {
        timestamp
        job {
          agent {
            ...AgentBadge_agent
            ...AgentUpgradeBanner_agent
            hostname
            version
            versionHasKnownIssues
            isDeprecated
            operatingSystem {
              name
            }
          }
        }
      }
    }
  `
});
